import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { extendBannerBubbleStylesheet } from "@devowl-wp/web-cookie-banner";
import { BannerStickyBubble } from "./bubble.js";
import { useBanner } from "../../../contexts/banner.js";
import { useStylesheet } from "../../../contexts/stylesheet.js";
import { useBannerStylesheet } from "../../../hooks/banner/useBannerStylesheet.js";
import { AnimatedCss } from "../../animateCss.js";
import { Portal } from "../../portal.js";
const BannerSticky = ()=>{
    if (process.env.PLUGIN_CTX === "pro") {
        /* onlypro:start */ const { visible, sticky: { animationsEnabled } } = useBanner();
        const { className } = useStylesheet();
        const stylesheet = useBannerStylesheet();
        const { stickyBar } = stylesheet.extend(...extendBannerBubbleStylesheet);
        const isAnimationEnabled = useRef(false);
        // The initial animation / on page switch should not be shown, but the fade animation
        // should take action when opening / closing the cookie banner
        useEffect(()=>{
            isAnimationEnabled.current = true;
        }, [
            visible
        ]);
        return /*#__PURE__*/ _jsx(Portal, {
            renderInContainer: document.body,
            children: /*#__PURE__*/ _jsx(AnimatedCss, {
                animationIn: animationsEnabled ? "fadeIn" : "none",
                animationInDuration: isAnimationEnabled.current && animationsEnabled ? 300 : 0,
                animationOut: animationsEnabled ? "fadeOut" : "none",
                animationOutDuration: animationsEnabled ? 300 : 0,
                isVisible: !visible,
                className: `${className} ${stylesheet.className} ${stickyBar}`,
                children: /*#__PURE__*/ _jsx(BannerStickyBubble, {})
            })
        });
    /* onlypro:end */ } else {
        return null;
    }
};
export { BannerSticky };
